import { styled } from '@mui/material';
import AppSimpleSelect from 'components/FormElements/AppSimpleSelect';
import InteractiveTable from 'components/InteractiveTable';

export const StyledSwitchContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gridGap: theme.spacing(2),
}));

export const StyledFiltersContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(3),
  marginBottom: theme.spacing(3),
  width: '100%',
}));

export const StyledSwitchLabel = styled('span')(({ theme }) => ({
  fontSize: theme.fontSizes.small,
  color: theme.palette.text.secondary,
}));

export const StyledFilterField = styled('div')(() => ({
  flex: 1,
}));

export const StyledArchiveStatusSelect = styled(AppSimpleSelect)(() => ({
  width: '100%',
}));

export const StyledContentEditable = styled('div')(({ theme }) => ({
  minHeight: theme.spacing(10),
  padding: theme.spacing(2),
  cursor: 'text',
  width: '100%',
  maxWidth: '100%',
  overflow: 'hidden',
  wordWrap: 'break-word',
  whiteSpace: 'pre-wrap',
  fontSize: theme.fontSizes.small,
  fontFamily: 'inherit',
  lineHeight: '1.4',
  boxSizing: 'border-box',
  display: 'flex',
  alignItems: 'center',
  outline: 'none',
}));

export const TableContainer = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(2),
  marginTop: theme.spacing(2),
}));

export const StyledTable = styled(InteractiveTable)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,

  // CSS for contentEditable placeholder
  '& [data-placeholder]:empty:before': {
    content: 'attr(data-placeholder)',
    color: theme.palette.text.hint,
    pointerEvents: 'none',
  },

  // Vertically center all cell content
  '& .MuiDataGrid-cell': {
    display: 'flex !important',
    alignItems: 'center !important',
  },
}));
